import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter", { email });
      toast.success(data.message || "Welcome to the circle");
      setEmail("");
    } catch {
      toast.error("Could not subscribe. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="relative mt-32 pt-20 pb-12 border-t border-lapis/10 bg-cream/40">
      <div className="absolute -top-12 left-1/2 -translate-x-1/2 w-24 h-24 rounded-full bg-peach/40 blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-12 relative">
        <div className="md:col-span-5">
          <div className="font-serif italic text-4xl text-lapis leading-tight">
            Just be you<span className="text-peach-deep">.</span>
          </div>
          <p className="mt-6 max-w-sm text-ink/70 leading-relaxed">
            A bright, slow space for manifestation, meditation, and remembering who
            you've always been. Curated with love by Mehjabin.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="overline mb-5">Wander</div>
          <ul className="space-y-3 text-ink/70 text-sm">
            <li><Link to="/shop" className="hover:text-lapis transition-colors">Shop</Link></li>
            <li><Link to="/bookings" className="hover:text-lapis transition-colors">Bookings</Link></li>
            <li><Link to="/library" className="hover:text-lapis transition-colors">Library</Link></li>
            <li><Link to="/about" className="hover:text-lapis transition-colors">About</Link></li>
            <li><Link to="/policies/contact" className="hover:text-lapis transition-colors" data-testid="footer-contact-link">Contact us</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="overline mb-5">Soft Letters</div>
          <p className="text-ink/70 text-sm mb-5 leading-relaxed">
            A gentle note arrives in your inbox each new moon. No noise. Only what feels useful.
          </p>
          <form onSubmit={submit} className="flex items-end gap-3" data-testid="newsletter-form">
            <input
              type="email" required placeholder="your email"
              value={email} onChange={(e) => setEmail(e.target.value)}
              className="eth-input flex-1"
              data-testid="newsletter-email-input"
            />
            <button
              type="submit" disabled={loading}
              className="text-lapis text-xs uppercase tracking-[0.2em] border-b border-lapis/40 pb-2 hover:border-lapis transition font-semibold"
              data-testid="newsletter-submit-btn"
            >
              {loading ? "..." : "Join"}
            </button>
          </form>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-16 pt-6 border-t border-lapis/10 text-xs text-ink/50 flex flex-col md:flex-row gap-3 justify-between">
        <span>© {new Date().getFullYear()} Just be you · by Mehjabin · All content is original work authored & owned by Mehjabin</span>
        <div className="flex flex-wrap gap-x-5 gap-y-2" data-testid="footer-policy-links">
          <Link to="/policies/terms" className="hover:text-lapis transition-colors">Terms</Link>
          <Link to="/policies/privacy" className="hover:text-lapis transition-colors">Privacy</Link>
          <Link to="/policies/refunds" className="hover:text-lapis transition-colors">Refunds & Cancellations</Link>
          <Link to="/policies/shipping" className="hover:text-lapis transition-colors">Shipping</Link>
          <Link to="/policies/contact" className="hover:text-lapis transition-colors">Contact</Link>
        </div>
        <span className="font-serif italic text-ink/60">held in care, returned in love</span>
      </div>
    </footer>
  );
}
